module.exports = __webpack_public_path__ + "img/swiper-1.81f3d5c9.png";